var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 91,
    viewBox: "0 0 470 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M459.765 87.4999L213.974 87.5L10.2353 87.4999L118.697 3.50002L351.303 3.50001L459.765 87.4999Z",
    fill: "url(#paint0_linear_29_360)",
    stroke: "black",
    strokeWidth: 7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_360",
    x1: 0,
    y1: 91,
    x2: -1.80336e-9,
    y2: 0.00000119209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#002846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#002846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.f90bd0819ff7ece1a3a89c11ec5c7d20.svg";
export { ForwardRef as ReactComponent };